import { RunnerUpHeader, UnderLine, TableWork } from '../../ui'
import './announceElection.css'
import * as XLSX from 'xlsx'
import RadioInput from '../../library/components/Radio/radio'
import Button from '../../library/components/Button'
import UploadFile from '../../library/components/FileUpload'
import { Validators } from '../../library/utilities/Validator'
import React, { useEffect, useState } from 'react'
import {
  useAnnounceElectionUploadFileMutation,
  useGetAllDetailsAnnounceElectionMutation,
  useGetStatesRequestQuery,
} from '../../services/announceElection'
import { useDispatch } from 'react-redux'
import { ALERT_TYPE_INFO, BROWSER_NOT_SUPPORT } from '../../constants/constants'
import SingleComponent from './SingleComponent'
import { createAlert } from '../../features/alert/alerts'
import { ALERT_TYPE_SUCCESS, ALERT_TYPE_ERROR } from '../../constants/constants'
import { commonApi } from '../../services/commonService'
import SelectField from '../../library/components/Select'
import { downloadExcel } from 'react-export-table-to-excel'
import LeftMenu from '../AnalyticsModule/Left'
import Table from "../../ui/datatable/DataTable";
import excelIcon from "../../dashboardicon/excel.svg";
import { useRef } from 'react'
import CustomModal from '../../library/components/Modal/modal'
import ConfirmationModal from '../../library/components/FileUpload/ConfirmationModal/ConfirmationModal'
import {EDIT} from '../../constants/constants'
import { useLocation, useNavigate } from 'react-router'
import RunnerUpHeaderNew from '../../ui/runnerUpHeader/RunnerUpHeaderNew'
const excelHeader = [
  "S.No",
  "State",
  "Election Type",
  "Constituency Type",
  "Constituency No. & Name",
  "Phase No",
  "State Phase No",
  "Date of Announcement of Election",
  "Last date for the withdrawal of candidates", 
  "End Date & Time",
  "Date of Poll",
  "Cut-off Date & Time",
  "Last Date of making nominations",
  "Date of Completion",
];
const templateTableHeader = [
  "ST_CODE",
  "ELECTION_TYPE",
  "CONST_TYPE_",
  "CONST_NO",
  "PHASE_NO",
  "STATE_PHASE_NO",
  "Date_of_Announcement_of_Election",
  "START_DATE",
  "END_DATE",
  "DATE_POLL",
  "CUT_OFF_DATE",
  "EROll_Finalization_Date_Time",
  "Date_of_Completion",
];


const AnnounceElections = () => {
  const [showConfirmationPopup,setShowConfirmationPopup] =useState(false)
  const [newFile, setnewFile] = useState('')
  const [isBulk, setIsBulk] = useState(true)
  const [updateUserData,setUpdateUserData]=useState()
  const tableHeader = [];
  const columns = [
    {
      Header: "S.No",
      accessor: "S_No",
    },
    {
      Header: "State",
      accessor: "stateCd",
    },
    {
      Header: "Election Type",
      accessor: "electionType",
    },
    {
      Header: "Constituency Type",
      accessor: "constType",
    },
    {
      Header: "Constituency",
      accessor: "constNo",
    },
    {
      Header: "Phase No",
      accessor: "phaseNo",
    },
    {
      Header: "State Phase No",
      accessor: "statePhaseNo",
    },
    {
      Header: "Date of Announcement of Election",
      accessor: "gazetteDate",
    },
    {
      Header: "Last date for the withdrawal of candidates",
      accessor: "startDateTime",
    },
    {
      Header: "End Date & Time",
      accessor: "endDateTime",
    },
    {
      Header: "Date of Poll",
      accessor: "datePoll",
    },
    {
      Header: "Cut-off Date & Time",
      accessor: "cutOffDateTime",
    },
    {
      Header: "Last Date of making nominations",
      accessor: "erollFinalDateTime",
    },
    {
      Header: "Date Of Completion",
      accessor: "dateOfCompletion",
    },
    {
      Header: 'Edit',
      accessor: 'Action',
    },
  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })

  const [uploadFile, datap] = useAnnounceElectionUploadFileMutation()
  const [getUsers, datac] = useGetAllDetailsAnnounceElectionMutation()
  const [states, setStates] = useState({ state: '' })
  const [isFinalizeButton, setFinalizeButton] = useState(false)
  const regex = /^([a-zA-Z0-9\s_\\.\-:()])+(.xls|.xlsx)$/
  const [isShowing, setIsShowing] = useState(true)
  const uploadFileRef=useRef()
  const [error, seterror] = useState({})
  const [isFileUpload, setIsFileUpload] = useState(false)
  const [totalNoOfRecords,setTotalNoOfRecords]=useState()
  const [Error, setError] = useState({})
  const [exeldata, setexeldata] = useState([])
  const [tableData, setTableData] = useState([])
  const templateTableData = [
    {
      "State": "String (3)",
      "Election Type": "GENERAL/BYE",
      "Constituency Type": "AC/PC",
      "Constituency No. & Name": "int",
      "Phase No": "int",
      "State Phase No": "int",
      "Date of Announcement of Election":"Date (dd-mm-yyyy)",
      "Last date for the withdrawal of candidates": "DateTime (dd-mm-yyyy h:mm AM/PM)",
      "End Date & Time": "DateTime (dd-mm-yyyy h:mm AM/PM)",
      "Date of Poll": "Date (dd-mm-yyyy)",
      "Cut-off Date & Time": "DateTime (dd-mm-yyyy h:mm AM/PM)",
      "Last Date of making nominations": "DateTime (dd-mm-yyyy h:mm AM/PM)",
      "Date of Completion" : "Date (dd-mm-yyyy)",
    }
  ]
  const dispatch = useDispatch();
  const { data: getAllState } = useGetStatesRequestQuery();
  const stateList = [{ value: "", label: " Select State" }];

  const userEdit=(item)=>{
    setIsBulk(false)
    setUpdateUserData(item)
  }


const getdata = ()=>{
  getUsers({ stateCd: states.state })
  .unwrap()
  .then((res) => {
    let tableData1 = []
    res?.payload?.map((item, i) => {
      tableData1.push({
        "S_No": i + 1,
        "stateCd": item.stateName,
        electionType: item.electionType,
        constType: item.constType,
        constNo: `${item.constNo}-${item.constName}`,
        phaseNo: item.phaseNo,
        statePhaseNo: item.statePhaseNo,
        gazetteDate:item.gazetteDate,
        startDateTime: item.startDateTime,
        endDateTime: item.endDateTime,
        datePoll: item.datePoll,
        cutOffDateTime: item.cutOffDateTime,
        erollFinalDateTime: item.erollFinalDateTime,
        dateOfCompletion: item.dateOfCompletion,
        Action: (
          <button
            className="UserEditButton"
            onClick={()=>userEdit(item)}
          >
            <i className="fa-solid fa-pencil edit-icon" />
            {EDIT}
          </button>
        ),
      })
      
    })
    setTableData(tableData1)
    setTotalNoOfRecords(res?.payload?.length)
   
  })
  .catch((error) => {
    setTableData([])
  })
}

  useEffect(() => {
    getdata()
  }, [states.state])

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: 'Success',
      }),
    )
  }

  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: 'Reject',
      }),
    )
  }

  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: 'Info',
      }),
    )
  }

  const getError = (key, value) => {
    let error = { ...Error }
    if (value && value.message) {
      setError({ ...Error, [key]: value.message })
    } else {
      delete error[key]
      setError(error)
    }
  }

  const processExcel = (data) => {
    const workbook = XLSX.read(data, { type: 'binary' })
    const firstSheet = workbook.SheetNames[0]
    const excelRows = XLSX.utils.sheet_to_row_object_array(
      workbook.Sheets[firstSheet],
    )

    let tableData2 = []
    excelRows?.map((item, i) => {
      tableData2.push({
        "S_No": i + 1,
        stateCd: item.ST_CODE ? item.ST_CODE : null,
        electionType: item.ELECTION_TYPE ? item.ELECTION_TYPE : null,
        constType: item.CONST_TYPE_ ? item.CONST_TYPE_ : null,
        constNo: item.CONST_NO ? item.CONST_NO : null,
        phaseNo: item.PHASE_NO ? item.PHASE_NO : null,
        statePhaseNo: item.STATE_PHASE_NO ? item.STATE_PHASE_NO : null,
        gazetteDate: item?.Date_of_Announcement_of_Election?item?.Date_of_Announcement_of_Election : null,
        startDateTime: item.START_DATE ? item.START_DATE : null,
        endDateTime: item.END_DATE ? item.END_DATE : null,
        datePoll: item.DATE_POLL ? item.DATE_POLL : null,
        cutOffDateTime: item.CUT_OFF_DATE ? item.CUT_OFF_DATE : null,
        erollFinalDateTime: item.EROll_Finalization_Date_Time ? item.EROll_Finalization_Date_Time : null,
        dateOfCompletion: item.Date_of_Completion ? item.Date_of_Completion : null
      })
    })
    setTableData(tableData2)
  }

  const changeHandler = (event) => {
    setnewFile(event.target.files[0])
  }

  const onReUpload = () => {
    uploadFileRef.current.removeFile()
    setTableData([])
    setFinalizeButton(false)
    setnewFile('')
    document.getElementById('inputFile').value = ''
  }
  const onExcelUpload = () => {

    let error = {}
    if (!newFile || newFile === '') {
      error['uploadFile'] = 'This field is required'
    }
    if (Object.keys(error).length) {
      setError(error)
      return
    }
    const fileUpload = document.getElementById('inputFile')
    if (regex.test(fileUpload.value.toLowerCase())) {
      if (typeof FileReader !== 'undefined') {
        const reader = new FileReader()
        if (reader.readAsBinaryString) {
          reader.onload = (e) => {
            processExcel(reader.result)
          }
          reader.readAsBinaryString(fileUpload.files[0])
          setIsFileUpload(true)
          setIsShowing(true)
          setFinalizeButton(true)
        }
      } else {
        alert(BROWSER_NOT_SUPPORT)
        document.getElementById('inputFile').value = ''
      }
    }
  };
  const handleTemplateDownload = () => {

    downloadExcel({
      fileName: "AnnounceElection Template",
      sheet: "AnnounceElection Template",
      tablePayload: {
        header: templateTableHeader,
        body: templateTableData,
      },
    });
  }

  const handleDownload = () => {
    console.log(tableData)
    downloadExcel({
      fileName: 'AnnounceElection details',
      sheet: 'AnnounceElection',
      tablePayload: {
        header: excelHeader,
        body: tableData,
      },
    })
  }

  const handleChange = (key, value, i) => {
    setStates((prevState) => ({
      ...prevState,
      [key]: value,
    }))
  }

  getAllState?.map((item) => {
    stateList?.push({
      value: item.stateCd,
      label: item.stateName,
    })
  })

  const onFinalize = async () => {
    if (tableData.length !== 0) {
      uploadFile(tableData)
        .unwrap()
        .then((res) => {
          onSuccess(res.message)
          document.getElementById('inputFile').value = ''
          setFinalizeButton(false)
          setStates({ state: '' })
          setnewFile('')
        })
        .catch((error) => { })
    } else {
      onInfo('Please Upload the File First !')
    }
    setShowConfirmationPopup(false)
  }

  return (
    <LeftMenu>
      {
        <CustomModal
        className="confirmation_modal"
        show={showConfirmationPopup}
        onClose={() => {
          setShowConfirmationPopup(false)
        }}
        size="500px"
        closeIcon={false}
        modalTitle={'Do you want to finalize ?'}
        children={
          <ConfirmationModal
            // title="You want to delete this"
            noOption={() => {setShowConfirmationPopup(false)}}
            yesOption={onFinalize}
          />
        }
        />
      }
      <div className="container box ">
         <RunnerUpHeaderNew 
      title={"Announce Election"}
      />
       {
        localStorage.userrole==="epba" &&  <div className="row ml-1">
        <div className="col-md-4">
          <label>Add election details</label>
        </div>
        <div className="col-md-8">
          <div className="row">
            <RadioInput
              onChange={(e) =>{ setIsBulk(e); getdata()}}
              value={true}
              label="Bulk Upload"
              checked={isBulk}
              name="radio1"
              inputClass=""
              labelClass=""
            />
            <RadioInput
              onChange={(e) => {setIsBulk(!e); setUpdateUserData()}}
              value={true}
              label="Add Single"
              checked={!isBulk}
              name="radio2"
              inputClass=""
              labelClass=""
            />
          </div>
        </div>
      </div>
       }
        {
          localStorage?.userrole==="epba" ?
          <>
        <UnderLine />
          <RunnerUpHeader label={isBulk ? "Bulk Upload" : "Add Single"} search={
          (
            isBulk &&
            <div className="col-md-4" style={{display: 'flex',justifyContent: 'end'}}>
                <button type="button" className="btn btn-light btn-sm announce_election_excel_template1 " onClick={handleTemplateDownload}>Download Template<span className="pl-2"><i class="fa-solid fa-download"></i></span></button>
            </div>
          )


        } />
        <div className="">
          {isBulk ? (
            <>
              <div className="col-md-4">
                <label>Upload Election details (in Excel)</label>
              </div>
              <div className="row">
                <div className="col-md-5 p-0">
                  <UploadFile
                    id="inputFile"
                    name="uploadFile"
                    labelClass="col-md-12"
                    inputClass="col-md-12"
                    validTypes={['.xlsx', '.xls']}
                    reference={uploadFileRef}
                    accept=".xlsx,.xls"
                    onChange={(ev) => changeHandler(ev, 'uploadFile')}
                    required={true}
                    size={2000}
                    getError={(val) => getError('uploadFile', val)}
                    Error={Error}
                    seterror={seterror}
                    validators={[
                      {
                        check: Validators.required,
                        message: 'This field is required',
                      },
                    ]}
                  />
                   <p className='text-danger ml-3'>(only .xls and .xlsx supported)</p>
                </div>
                <div className="col-md-4 pl-0 upload-row mb-2">
                  {Object.keys(error).length !== 0 ? (
                    ''
                  ) : (
                    <>
                      {' '}
                      <button
                        type="button"
                        className="btn btn-primary btn-sm upload-master-button"
                        onClick={onExcelUpload}
                      >
                        Upload
                        <span className="pl-2">
                          <i class="fa-solid fa-upload"></i>
                        </span>
                      </button>
                      <button
                        type="button"
                        className="btn btn-success btn-sm upload-master-button"
                        style={{ width: '120px' }}
                        onClick={onReUpload}
                      >
                        Re-Upload
                        <span className="pl-2">
                          <i class="fa-solid fa-upload"></i>
                        </span>
                      </button>
                    </>
                  )}
                </div>
                <div className="col-md-3" style={{display: 'flex',justifyContent: 'end',cursor:'pointer'}}>
                  <img src={excelIcon} width="40px" height="30px" onClick={handleDownload} />
                </div>
                {/* <div className="col-md-12">
                  <RunnerUpHeader
                    label={'Election Schedule Table'}
                    search={
                      <div className="col-md-4 offset-md-6 announce-dropdown">
                        <SelectField
                          labelClass="col-md-0"
                          style={{ position: 'relative', bottom: '5px' }}
                          inputClass="col-md-6"
                          disabled={false}
                          name="state"
                          value={states.state}
                          handleChange={(val, i) =>
                            handleChange('state', val, i)
                          }
                          options={stateList}
                        />
                        <button
                          type="button"
                          className="btn btn-primary btn-sm announce_download_button"
                          onClick={handleDownload}
                        >
                          Download
                          <span className="pl-2">
                            <i class="fa-solid fa-download"></i>
                          </span>
                        </button>
                      </div>
                    }
                  />
                </div> */}
                {isShowing ? (
                  <div className="col-md-12">
                    <Table
                      placeholder="Search"
                      globalsearch={true}
                      selectall={true}
                      emptyMessage="No Record Found"
                      columns={columns}
                      records
                      data={tableData?.length === 0 ? [] : tableData}
                      size={5}
                      tableClassNameCheck="contenttable-eroll"
                      pagination
                      gotopage
                      rows
                      numberrows={totalNoOfRecords}
                    />
                    {/* <TableWork
                      id=""
                      theadData={tableHeader}
                      tbodyData={tableData}
                      anchorTagName=""
                      anchorTagclassName="viewDetails"
                      emptyMessage="No data found"
                      pageSize={10}
                      pagination={true}
                      paginationClass={'text-right p-0'}
                    /> */}
                  </div>
                ) : (
                  ''
                )}
                {isFinalizeButton ? (
                  <div className="finalize_button col-md-2">
                    <Button
                      className="btn-class"
                      value="Finalize"
                      onClick={()=>setShowConfirmationPopup(true)}
                    />
                  </div>
                ) : (
                  ''
                )}
              </div>
            </>
          ) : (
            <SingleComponent
              updateUserData={updateUserData}
              tableHeader={tableHeader}
              isShowing={isShowing}
              setIsShowing={setIsShowing}
              getUsers={getUsers}
            />
          )}
        </div>
          </>:
          <>
                <div className="col-md-12" style={{display: 'flex',justifyContent: 'end',cursor:'pointer'}}>
                  <img src={excelIcon} width="40px" height="30px" onClick={handleDownload} />
                </div>
                <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          emptyMessage="No Record Found"
          columns={columns.splice(0,14)}
          records
          data={tableData?.length === 0 ? [] : tableData}
          size={5}
          tableClassNameCheck="contenttable-eroll"
          pagination
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
          </>
          
        }
      </div>
    </LeftMenu>
  )
}
export default AnnounceElections
